"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryLine = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _es = require("victory-line/es");

var _victoryLabel = require("./victory-label");

var _victoryContainer = require("./victory-container");

var _victoryClipContainer = require("./victory-clip-container");

var _curve = require("./victory-primitives/curve");

var _wrapCoreComponent = require("../helpers/wrap-core-component");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VictoryLine = (0, _wrapCoreComponent.wrapCoreComponent)({
  Component: _es.VictoryLine,
  defaultProps: _objectSpread(_objectSpread({}, _es.VictoryLine.defaultProps), {}, {
    dataComponent: /*#__PURE__*/_react.default.createElement(_curve.Curve, null),
    labelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    containerComponent: /*#__PURE__*/_react.default.createElement(_victoryContainer.VictoryContainer, null),
    groupComponent: /*#__PURE__*/_react.default.createElement(_victoryClipContainer.VictoryClipContainer, null),
    width: _reactNative.Dimensions.get("window").width
  })
});
exports.VictoryLine = VictoryLine;